//FAQ
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ctm_multifaq_title_main").forEach((section) => {
    const questions = section.querySelectorAll(".faq_question");
    let previousActiveQuestion = null;

    questions.forEach((question, index) => {
      const icon = question.querySelector(".icon-shape");
      const answer = question.nextElementSibling;

      // Toggle logic on click
      question.addEventListener("click", () => {
        // Close previous active
        if (previousActiveQuestion && previousActiveQuestion !== question) {
          previousActiveQuestion.classList.remove("active");
          previousActiveQuestion
            .querySelector(".icon-shape")
            .classList.remove("active");
          const prevAnswer = previousActiveQuestion.nextElementSibling;
          prevAnswer.style.maxHeight = "0";
        }

        // Toggle current
        question.classList.toggle("active");
        icon.classList.toggle("active");

        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          previousActiveQuestion = question;
        } else {
          answer.style.maxHeight = "0";
          previousActiveQuestion = null;
        }
      });

      // Handle pre-opened state via `.open` class (Shopify setting)
      if (question.classList.contains("open")) {
        question.classList.add("active");
        icon.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        previousActiveQuestion = question;
      }

      // ✅ Automatically open the first question by default if none marked `.open`
      // if (index === 0 && !section.querySelector(".faq_question.open")) {
      //   question.classList.add("active");
      //   icon.classList.add("active");
      //   answer.style.maxHeight = answer.scrollHeight + "px";
      //   previousActiveQuestion = question;
      // }
    });
  });
});

// header menu hover
document.querySelectorAll("header-menu details").forEach((details) => {
  details.addEventListener("mouseenter", () => {
    details.setAttribute("open", "");
  });

  details.addEventListener("mouseleave", () => {
    details.removeAttribute("open");
  });

  const equalizeHeadings = () => {
    const headings = document.querySelectorAll(
      ".card-wrapper .card .card__heading",
    );
    if (!headings.length) {
      return;
    }

    // reset
    headings.forEach((h) => {
      h.style.height = "auto";
    });

    // find tallest
    const maxHeight = Math.max(...[...headings].map((h) => h.offsetHeight));

    // apply
    headings.forEach((h) => {
      h.style.height = `${maxHeight}px`;
    });
  };

  document.addEventListener("DOMContentLoaded", equalizeHeadings);
  window.addEventListener("resize", equalizeHeadings);
});

document.addEventListener("DOMContentLoaded", () => {
  const salePriceSettings = window.BenjieSalePriceSettings;
  const salePriceSelector =
    ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price";

  if (
    salePriceSettings?.enabled &&
    !salePriceSettings.productExcluded &&
    salePriceSettings.percentage > 0
  ) {
    const updateLoopWidgetPrices = () => {
      document.querySelectorAll(salePriceSelector).forEach((priceElement) => {
        const currentText = priceElement.textContent;
        if (priceElement.dataset.benjieRenderedText === currentText) {
          return;
        }

        const originalText = currentText;
        const priceMatch = originalText.match(/\d[\d,]*(?:\.\d+)?/);

        if (!priceMatch) {
          return;
        }

        const originalPrice = Number(priceMatch[0].replace(/,/g, ""));
        if (!Number.isFinite(originalPrice)) {
          return;
        }

        const decimalPlaces = (priceMatch[0].split(".")[1] || "").length;
        const salePrice = (
          originalPrice *
          (1 - salePriceSettings.percentage / 100)
        ).toFixed(decimalPlaces);
        const formattedSalePrice = priceMatch[0].includes(",")
          ? Number(salePrice).toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            })
          : salePrice;
        const saleText = originalText.replace(
          priceMatch[0],
          formattedSalePrice,
        );

        if (salePriceSettings.display === "price_and_sale_price") {
          priceElement.innerHTML = `<s class="loop-widget-original-price">${originalText}</s> <span>${saleText}</span>`;
        } else if (salePriceSettings.display === "sale_price_percentage") {
          priceElement.innerHTML = `<span>${saleText}</span> <span class="loop-widget-sale-percentage">${salePriceSettings.percentage}% off</span>`;
        } else {
          priceElement.textContent = saleText;
        }
        priceElement.dataset.benjieRenderedText = priceElement.textContent;
      });
    };

    updateLoopWidgetPrices();
    new MutationObserver(updateLoopWidgetPrices).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // pdp media gallery slider
  const thumbSliderEl = document.querySelector(
    ".ctm_pdp_mainproduct_thumbnail_slider",
  );
  let swiperThumbs = null;
  if (thumbSliderEl) {
    const thumbSlidesCount =
      thumbSliderEl.querySelectorAll(".swiper-slide").length;

    const enableThumbLoop = thumbSlidesCount > 4;

    swiperThumbs = new Swiper(".ctm_pdp_mainproduct_thumbnail_slider", {
      direction: "vertical",
      loop: enableThumbLoop,
      spaceBetween: 14,
      slidesPerView: 4,
      speed: 600,
      watchSlidesProgress: true,

      navigation: enableThumbLoop
        ? {
            nextEl: ".product-slider-next",
            prevEl: ".product-slider-prev",
          }
        : false,

      breakpoints: {
        0: {
          direction: "horizontal",
          spaceBetween: 8,
          slidesPerView: 4,
        },
        768: {
          direction: "horizontal",
          spaceBetween: 16,
          slidesPerView: 4,
        },
        1025: {
          direction: "vertical",
          spaceBetween: 14,
          slidesPerView: 4,
        },
      },
    });

    if (thumbSlidesCount <= 4) {
      document
        .querySelectorAll(".product-slider-next, .product-slider-prev")
        .forEach((el) => (el.style.display = "none"));
    }
  }
  new Swiper(".ctm_pdp_mainproduct_slider", {
    slidesPerView: 1,
    grabCursor: true,
    draggable: true,
    loop: true,
    spaceBetween: 0,
    speed: 600,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".product-slider-next-main.swiper-button-next-main",
      prevEl: ".product-slider-prev-main.swiper-button-prev-main",
    },
    thumbs: swiperThumbs
      ? {
          swiper: swiperThumbs,
        }
      : null,
    breakpoints: {
      0: {
        spaceBetween: 8,
        slidesPerView: 1.15,
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 1.75,
      },
      1025: {
        spaceBetween: 0,
        slidesPerView: 1,
      },
    },
  });

  const announcement = document.querySelector(".announcement-bar-section");
  const header = document.querySelector(".header-wrapper");

  if (announcement instanceof HTMLElement) {
    const announcementHeight = announcement.offsetHeight;
    document.body.style.setProperty(
      "--announcement-height",
      `${announcementHeight}px`,
    );
  }

  if (header instanceof HTMLElement) {
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
  }

  //combined height (announcement + header)
  if (announcement instanceof HTMLElement && header instanceof HTMLElement) {
    const totalHeight = announcement.offsetHeight + header.offsetHeight;
    document.body.style.setProperty(
      "--announcement-header-height",
      `${totalHeight}px`,
    );
  }

  function removeExtraCart() {
    if (window.innerWidth <= 990) {
      // Mobile view — remove desktop announcement cart
      const desktopCarts = document.getElementsByClassName("annoucement-cart");
      if (desktopCarts.length) {
        Array.from(desktopCarts).forEach((el) => el.remove());
      }
    } else {
      // Desktop view — remove mobile header cart
      const mobileCarts = document.getElementsByClassName("header-cart");
      if (mobileCarts.length) {
        Array.from(mobileCarts).forEach((el) => el.remove());
      }
    }
  }

  removeExtraCart();

  // Handle window resize
  window.addEventListener("resize", removeExtraCart);

  // Get form elements
  const form = document.querySelector('form[action*="account"]');
  const password = document.getElementById("RegisterForm-password");
  const confirmPassword = document.getElementById(
    "RegisterForm-password-confirmation",
  );
  const errorDiv = document.getElementById("password-error");
  const submitButton = document.getElementById("register-button");

  // Check if all elements exist
  if (!form || !password || !confirmPassword || !errorDiv || !submitButton) {
    console.warn("One or more form elements not found:", {
      form,
      password,
      confirmPassword,
      errorDiv,
      submitButton,
    });
    return; // stop execution
  }

  // Function to validate passwords
  function validatePasswords() {
    // Hide error if either field is empty
    if (password.value === "" || confirmPassword.value === "") {
      errorDiv.style.display = "none";
      confirmPassword.setCustomValidity("");
      return true;
    }

    // Show error if passwords don't match
    if (password.value !== confirmPassword.value) {
      errorDiv.style.display = "block";
      confirmPassword.setCustomValidity("Passwords do not match");
      return false;
    }

    // Passwords match
    errorDiv.style.display = "none";
    confirmPassword.setCustomValidity("");
    return true;
  }

  // Validate on form submission
  form.addEventListener("submit", (e) => {
    if (!validatePasswords()) {
      e.preventDefault();
      return false;
    }
  });

  // Real-time validation on input
  confirmPassword.addEventListener("input", validatePasswords);
  password.addEventListener("input", () => {
    if (confirmPassword.value) {
      validatePasswords();
    }
  });
});

// function initRelatedProductsSwiper(sectionId) {
//   if (window.innerWidth < 989) {
//     const container = document.querySelector(
//       `#shopify-section-${sectionId} .related-products-slider`,
//     );
//     if (container && !container.classList.contains("swiper-initialized")) {
//       new Swiper(container, {
//         slidesPerView: 1.2,
//         spaceBetween: 16,
//         loop: false,
//         breakpoints: {
//           640: {
//             slidesPerView: 2,
//           },
//         },
//       });
//     }
//   }
// }

// // Initialize once DOM is ready
// document.addEventListener("DOMContentLoaded", function () {
//   initRelatedProductsSwiper("{{ section.id }}");
// });

// // Re-initialize after recommendations AJAX loads
// document.addEventListener("product-recommendations:updated", function (e) {
//   const section = e.target.closest("[data-section-id]");
//   if (section && section.dataset.sectionId === "{{ section.id }}") {
//     initRelatedProductsSwiper(section.dataset.sectionId);
//   }
// });

// header shadow
const header = document.querySelector(".header");

window.addEventListener("scroll", () => {
  if (window.scrollY > 10) {
    header.classList.add("shadow-lg", "py-0");
    header.classList.remove("py-[10px]");
  } else {
    header.classList.remove("shadow-lg", "py-0");
    header.classList.add("py-[10px]");
  }
});
